import React from 'react'

import SponsorHero from "./SponsorHero"
import SponsorSection from './SponsorSection'


export default function Sponsors() {
  return (
    <>
    <SponsorHero/>
    <SponsorSection/>
    
    </>
  )
}
